import { useEffect, useState } from "react";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const List = ({ items, tone }) => (
  <div className="max-h-72 overflow-y-auto divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white" data-testid={`elig-list-${tone}`}>
    {items.map((r) => (
      <div key={r.rider_id} className="flex items-center justify-between gap-2 px-3 py-2 text-sm">
        <span className="font-semibold text-slate-800 truncate">{r.name || "—"}{!r.matched && <span className="ms-1 text-[10px] text-amber-600">(غير مربوط)</span>}</span>
        <span className="text-xs text-slate-500" dir="ltr">{r.rider_id}{tone === "no" && r.reason ? ` · ${r.reason}` : ""}</span>
      </div>
    ))}
    {!items.length && <p className="p-3 text-center text-xs text-slate-400">لا يوجد</p>}
  </div>
);

export const InvoiceEligibility = ({ invoiceId }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState("");
  useEffect(() => { setD(null); setOpen(""); api.invoiceEligibility(invoiceId).then(setD).catch(() => setD({ found: false, reason: "تعذّر قراءة شيت Breakdown" })); }, [invoiceId]);
  if (!d) return <div className="py-3 text-center text-slate-400"><Loader2 className="mx-auto h-4 w-4 animate-spin" /></div>;
  if (!d.found) return <p className="mt-3 rounded-xl border border-dashed border-slate-200 p-3 text-xs text-slate-500" data-testid="elig-missing">{d.reason}</p>;
  const Box = ({ k, n, label, Icon, cls }) => (
    <button data-testid={`elig-box-${k}`} onClick={() => setOpen(open === k ? "" : k)}
      className={`flex-1 rounded-2xl border p-4 text-start transition-transform active:scale-95 ${cls} ${open === k ? "ring-2 ring-offset-1" : ""}`}>
      <div className="flex items-center gap-2 text-sm font-semibold"><Icon className="h-4 w-4" /> {label}</div>
      <div className="mt-1 font-heading text-3xl font-bold" data-testid={`elig-count-${k}`}>{n}</div>
      <div className="text-[11px] opacity-70">اضغط لعرض الأسماء</div>
    </button>
  );
  return (
    <div className="mt-4 space-y-2" data-testid="invoice-eligibility">
      <p className="text-xs text-slate-500">صلاحية المناديب من شيت Breakdown (عمود: <b dir="ltr">{d.column}</b>)</p>
      <div className="flex gap-3">
        <Box k="ok" n={d.eligible.length} label="مندوب صالح" Icon={CheckCircle2} cls="border-emerald-200 bg-emerald-50 text-emerald-700 ring-emerald-300" />
        <Box k="no" n={d.ineligible.length} label="مندوب غير صالح" Icon={XCircle} cls="border-red-200 bg-red-50 text-red-700 ring-red-300" />
      </div>
      {open && <List items={open === "ok" ? d.eligible : d.ineligible} tone={open} />}
    </div>
  );
};
